import { faCircleCheck, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { If } from 'aa_common/front-end/components'
import { Col, Collapse as AntCollapse, Image, Row, Typography } from 'antd'
import classNames from 'classnames'
import { EMPTY_SYMBOL } from 'common/constants'
import { getNs } from 'common/i18n-config'

import { CardContent, Collapse, RegisterInMaster, Warning } from '../styles'
import { Suggestion } from '../types'

const { t, useNsReady } = getNs(['common', 'components/organisms/assets/asset-form'])
const { Text, Title } = Typography
const { Panel } = AntCollapse

type AICardContentProps = {
  data: Suggestion
  imageSrc?: string
  onClick?: () => void
  selected?: boolean
  isRegisteredCategory?: boolean
}

export const AICardContent = ({ data, imageSrc, onClick, selected, isRegisteredCategory }: AICardContentProps) => {
  useNsReady()

  return (
    <CardContent className={classNames({ selected })} onClick={onClick} style={{ position: 'relative' }}>
      <If condition={selected}>
        <FontAwesomeIcon
          icon={faCircleCheck}
          data-testid="check-icon"
          style={{
            position: 'absolute',
            top: 12,
            right: 12,
            fontSize: 20,
            color: '#3b7de9',
          }}
        />
      </If>
      <Row gutter={24} justify="space-between">
        {/* Image */}
        <If condition={imageSrc}>
          <Col span={6}>
            <Image width={96} src={imageSrc} />
          </Col>
        </If>

        {/* Details */}
        <Col span={imageSrc ? 17 : 24}>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <div>
                <Text type="secondary">{t('name')}</Text>
                <Title level={5}>{data?.asset_name}</Title>
              </div>
            </Col>

            <Col span={14}>
              <div>
                <Text type="secondary">{t('asset_category')}</Text>
                <Title level={5} style={{ color: '#3b7de9' }}>
                  {data?.asset_category_name}
                </Title>
              </div>
            </Col>

            <Col>
              <div>
                <Text type="secondary">{t('service_life')}</Text>
                <Title level={5} style={{ color: '#3b7de9' }}>
                  <If condition={data?.service_life !== null}>
                    {data?.service_life}
                    {t('units.year')}
                  </If>
                  <If condition={data?.service_life === null}>{EMPTY_SYMBOL}</If>
                </Title>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <Collapse accordion>
        <Panel header={t('show_decision_rationale')} key="1">
          <If condition={!isRegisteredCategory}>
            <Text>{t('similar_case_based_on_nta_info_notice')}</Text>
            <If condition={data?.nta_link}>
              <Text>
                {t('reference')}: {t('national_tax_agency')}
                <a href={data?.nta_link} target="_blank" rel="noreferrer">
                  {t('link')}
                </a>
              </Text>
            </If>
            <Text>{data?.logic_path}</Text>
          </If>
          <If condition={isRegisteredCategory}>
            <Text>{t('similar_asset_category_master_notice')}</Text>
            <Text>
              {t('reference')}: {t('asset_category_master')}
              {' > '}
              {data.asset_category_name}
            </Text>
          </If>
        </Panel>
      </Collapse>

      <If condition={data?.is_proposed_new_category}>
        <Warning>
          <Row gutter={16} justify="space-between" align="middle">
            <Col span={15}>
              <Row justify="space-between" align="middle">
                <Col span={4}>
                  <FontAwesomeIcon
                    icon={faTriangleExclamation}
                    style={{
                      fontSize: 24,
                      color: '#fab300',
                    }}
                  />
                </Col>
                <Col span={20}>
                  <Text>{t('ai_warning_unregistered_asset_category')}</Text>
                </Col>
              </Row>
            </Col>
            <Col span={9}>
              <RegisterInMaster to="/master/asset-categories/new">{t('register_in_master')}</RegisterInMaster>
            </Col>
          </Row>
        </Warning>
      </If>
    </CardContent>
  )
}
